<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Edit Port</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="port.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="port.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="port.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Station
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="port.station_id" name="station_id">
                                        <md-option
                                                v-for="station in available_station_dropdown"
                                                :key="station.id"
                                                :value="station.id"
                                        >
                                            {{ station.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Port</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        port: {
            type: 'ports',
            name: null,
            short_name: null,
            code: null,
            station_id: null,
        },
        available_station_dropdown: [],
        station_dropdown: [],

    }),

    created () {
        this.get();
        this.getStationDropDowns();
    },
    methods: {
        async get () {
            try {
                const params = {
                    id: this.$route.params.id,
                    include:'station,labourers,workplaces'
                };
                await this.$store.dispatch('ports/show', params);
                this.port = this.$store.getters['ports/port'];
                this.station = this.port.station;
                this.port.station_id = this.station.id;
            } catch (e) {
                this.notifyException(e);
            }
        },

        async update () {
            try {
                await this.$store.dispatch('ports/update', this.port);
                await this.$store.dispatch(
                    'alerts/success',
                    'Port updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getStationDropDowns () {
            this.$store.dispatch('stations/list').then(() => {
                this.available_station_dropdown = this.$store.getters['stations/dropdown'];
            });
        },

        goBack () {
            this.$router.push({ name: 'Ports List' });
        },
    },
};
</script>
